import { phoneValidatorRequired } from "@asd/customer-portal-ui";
import { useMask } from "@react-input/mask";
import { Controller } from "react-hook-form";

import TextEdit from "./TextEdit";

interface PhoneTextEditProps {
  name: string;
  control: any;
  isRequired: boolean;
}

const PhoneTextEdit = ({ name, control, isRequired }: PhoneTextEditProps) => {
  const phoneInputRef = useMask({
    mask: "(___) ___-____",
    replacement: { _: /\d/ },
    modify: ({ value, data, selectionStart, selectionEnd }) => {
      const newValue = value.slice(0, selectionStart) + (data ?? "") + value.slice(selectionEnd);
      return { showMask: !!newValue?.length && /\d/.test(newValue) };
    },
  });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => <TextEdit {...field} error={error?.message} inputRef={phoneInputRef} />}
      rules={{
        ...phoneValidatorRequired,
        ...(!isRequired && { required: false }),
      }}
    />
  );
};

export default PhoneTextEdit;
